// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"177":"home","198":"board","787":"sponsor"}[chunkId] + "." + {"177":"651050eb","198":"691c178f","787":"2510ed25"}[chunkId] + ".js";
};